import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const Text = styled.span<{ size?: number; color?: string }>`
    font-size: ${({ size }) => size ?? 14}px;
    color: ${({ color }) => color ?? 'var(--color-black)'};
`

export const Item = styled.div`
    width: 100%;
    margin-bottom: 12px;
    > * {
        margin-top: 12px;
    }
`

export const Icon = styled(IconFont)<{ size?: number; ml?: number }>`
    font-size: ${({ size }) => size ?? '16'}px;
    margin-left: ${({ ml }) => ml ?? 0}px;
    vertical-align: middle;
`

export const RowList = styled.div``

export const RowItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
`

export const RowItemLeft = styled.div`
    display: flex;
    align-items: center;
`

export const RowText = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
    line-height: 22px;
`

export const RowItemRight = styled.div``

export const TooltipContent = styled.div`
    line-height: 22px;
    vertical-align: middle;
`
